module.exports = __webpack_public_path__ + "ffcc050b2d92d4b14a4fcb527ee0bcc8.woff";